import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IPackages } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useRef, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";

const schema = yup.object({
    title: yup.string().required("Title is required*"),
    details: yup.string().required("Details is required*")
});

interface Iprops {
    singleData: IPackages,
    open: boolean,
    hideDialog: () => void,
    reloadData: () => void,
    toast: any,

}

export const AddInfo = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);
    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false } as { data: IPackages[], count: number, loading: boolean });
    const [editRow, setEditRow] = useState<any | null>(null);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IPackages>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    const dt = useRef<any>(null);


    useEffect(() => {
        if (props.open) {
            loadTableData();
        }
    }, [props.open]);

    const saveToDB = async (body: any) => {
        body.package_ID = props.singleData.id;
        setSubmitting(true);
        let endpoint = `SitePackage/AddInfo`;
        if (editRow?.id) {
            endpoint = `SitePackage/updateInfo`;
        }
        const response = await Fetch(endpoint, "POST", body, null, props.toast);
        if (response) {
            // onHide();
            props.toast.current.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
            //props.reloadData();
            loadTableData();
        }
        setSubmitting(false);
    }

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch("SitePackage/AddInfo", "GET", null, `id=${props.singleData.id}`, props.toast);
        if (response) {
            const data: { sitePackage: IPackages[], count: number } = await response.json();
            setTableData({ data: data.sitePackage, count: data.count, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }



    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: any) {

        saveToDB(data);

    }

    const onEdit = (rowData: any) => {
        setEditRow(rowData);
        reset({
            ...rowData,
        });
    };

    const actionBodyTemplate = (rowData: any) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className='p-button-success p-button-text p-0' onClick={() => onEdit(rowData)} tooltip="Edit" />

            </div>
        );
    };

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '900px' }} header="Add Package Info" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required column={2} label="Title" control={control} name="title" error={errors.title?.message} />
                <JVInput required column={2} label="Details" control={control} name="details" error={errors.details?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                </div>
            </form>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                header="Add Info"
                loading={tableData.loading}
            >
                <Column field="id" header="ID" sortable />
                <Column field="title" header="Title" sortable />
                <Column field="details" header="Details" sortable />
                <Column body={actionBodyTemplate} />
            </DataTable>
        </Dialog>
    );
}